import { ProductBuilderMachineContext } from '../types';
import { getBaseProduct } from './getBaseProduct';

type GetFrameStyleOptions = (context: ProductBuilderMachineContext) => string[];
type FittingFrameOptionsType = {
  [key: string]: string[];
};

const fittingFrameOptions: FittingFrameOptionsType = {
  'Reveal Fit': ['Combination Frame'],
  'Face Fit': ['Decorative Face Fit Frame', 'Face Fit Frame'],
};

export const getFrameStyleOptions: GetFrameStyleOptions = context => {
  const baseProduct = getBaseProduct(context);
  if (!baseProduct) return [];

  const fitting = context.custom.fitting;
  const {
    metafields: { frame_style },
  } = baseProduct;

  return frame_style && fitting
    ? frame_style.filter(option =>
        fittingFrameOptions[fitting].includes(option),
      )
    : [];
};
